import React from 'react'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import TextField from '@mui/material/TextField'
import withActiveStation from '../../station/withActiveStation'
import type { VitrineProductWithWeight } from './vitrineProductTypes'
import type { Station } from '../../station/stationTypes'
import css from './vitrineProductTable.css'
import { i18n } from '../../index'
type Props = {
  data: VitrineProductWithWeight
  activeStation: Station
  onChange: (...args: Array<any>) => any
  onSubmit: (...args: Array<any>) => any
}

@withActiveStation
class VitrineProductWeightsRow extends React.PureComponent<Props> {
  onSubmit = () => {
    const { onSubmit, data } = this.props

    if (data.weight > 0) {
      onSubmit(data)
    }
  }

  render() {
    const { data, onChange, onSubmit } = this.props
    const weightIsValid = data.isPublic || data.weight > 0
    return (
      <TableRow>
        <TableCell className={css.tableCell}>{data.name}</TableCell>
        <TableCell className={css.tableCell}>
          <TextField
            error={!weightIsValid}
            helperText={!weightIsValid && i18n.t('admin.vitrineProducts.weights.warning')}
            type='number'
            value={weightIsValid ? data.weight : ''}
            onBlur={this.onSubmit}
            onKeyPress={(e) => (e.key === 'Enter' ? onSubmit(data) : null)}
            onChange={(e) => onChange(e.target.value)}
            disabled={data.isPublic}
          />
        </TableCell>
      </TableRow>
    )
  }
}

export default VitrineProductWeightsRow
